import { render, staticRenderFns } from "./AppliedLessonsList.vue?vue&type=template&id=0b98fe34&"
import script from "./AppliedLessonsList.vue?vue&type=script&lang=ts&"
export * from "./AppliedLessonsList.vue?vue&type=script&lang=ts&"
import style0 from "./AppliedLessonsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports